<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M11.5397 22.351c.0303.0175.054.0311.0708.0405l.0279.0156c.2229.1223.4994.1214.7224.0004l.0287-.016c.0168-.0094.0405-.023.0708-.0405.0604-.035.1467-.086.2552-.1528.217-.1336.5233-.3306.8891-.5891.7305-.516 1.7051-1.2817 2.6819-2.2818C18.2307 17.3368 20.25 14.3462 20.25 10.5c0-4.55635-3.6937-8.25-8.25-8.25-4.55635 0-8.25 3.69365-8.25 8.25 0 3.8462 2.01932 6.8368 3.96346 8.8273.97679 1.0001 1.95145 1.7658 2.68194 2.2818.3658.2585.6721.4555.8891.5891.1085.0668.1948.1178.2552.1528ZM12 13.5c1.6569 0 3-1.3431 3-3 0-1.65685-1.3431-3-3-3s-3 1.34315-3 3c0 1.6569 1.3431 3 3 3Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 4c-3.58985 0-6.5 2.91015-6.5 6.5 0 3.2043 1.68257 5.7792 3.46539 7.6046.88511.9062 1.77311 1.6042 2.43971 2.0752.2284.1614.4298.2953.5949.4012.1651-.1059.3665-.2398.5949-.4012.6666-.471 1.5546-1.169 2.4397-2.0752C16.8174 16.2792 18.5 13.7043 18.5 10.5 18.5 6.91015 15.5899 4 12 4Zm0 17.75c-.4804.8771-.4807.8769-.4811.8767l-.0009-.0005-.0023-.0013-.0066-.0036-.0213-.0119c-.0176-.01-.0423-.024-.0734-.042-.0622-.0361-.1505-.0883-.261-.1563-.2209-.1361-.5316-.336-.9023-.5978-.73955-.5225-1.7266-1.2978-2.71649-2.3113C5.56743 17.4879 3.5 14.4379 3.5 10.5 3.5 5.80558 7.30558 2 12 2c4.6944 0 8.5 3.80558 8.5 8.5 0 3.9379-2.0674 6.9879-4.0346 9.002-.9899 1.0135-1.9769 1.7888-2.7165 2.3113-.3707.2618-.6814.4617-.9023.5978-.1105.068-.1988.1202-.261.1563-.0311.018-.0558.032-.0734.042l-.0213.0119-.0066.0036-.0023.0013-.0009.0005c-.0004.0002-.0007.0004-.4811-.8767Zm0 0 .4804.8771c-.2993.1639-.6615.1639-.9608 0L12 21.75ZM12 8.5c-1.1046 0-2 .89543-2 2 0 1.1046.8954 2 2 2s2-.8954 2-2c0-1.10457-.8954-2-2-2Zm-4 2c0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4 0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
